const USERSVIEW = {
  listUsers: "Lista de usuários",
  updateUser: "Atualizar usuário",
  newUser: "Novo usuário",
  search: "Procurar",
  headTable: {
    user: "Do utilizador",
    email: "E-mail",
    phone: "Telefone",
    company: "Companhia",
    rol: "Função",
    state: "Doença",
    actions: "Ações"
  },
  dropdowm: {
    update: "Atualizar",
    all: "Tudo",
    active: "Ativo",
    inactive: "Inativo",
    eliminated: "Eliminado"
  },
  confirmActive: {
    title: "Confirmação",
    text: `Você deseja ativar o usuário {name} {lastname}`
  },
  deleteUser: {
    title: `Deletar usuário: {email}`,
    text: `Confirme que você deseja excluir o usuário?`,
    acceptText: "Aceitar",
    cancelText: "Cancelar"
  },
  deleteItemError: {
    title: "Excluir usuários",
    text: "Ocorreu um erro ao excluir o usuário",
    acceptText: "Aceitar",
    cancelText: "Cancelar"
  },
  state: {
    active: "Ativo",
    inactive: "Inativo",
    removed: "Removido",
    Active: "Ativo",
    Inactive: "Inativo"
  },

  formEditUser: {
    name: "Nomes",
    lastName: "Last name",
    email: "Email de contato",
    address: "Endereço",
    rol: "Função",
    deparment: "Departamento",
    city: "Cidade",
    company: "Companhia",
    languages: "Idioma (localidade)",
    password: "Senha",
    repeatPass: "Repita a senha",
    status: "Status"
  },
  btn: {
    clean: "Limpar",
    create: "Para criar",
    update: "Atualizar"
  },
  assignForm: {
    title: "Atribuir formulários",
    name: "Nome/Atividade",
    type: "Cara",
    group: "Conjunto",
    created: "Criada",
    state: "Doença"
  },
  BOT: {
    searchBot: "Bot do formulário de pesquisa...",
    searchUser: "Pesquisar usuário",
    title: "Formulários",
    selectAll: "Selecionar tudo",
    created: "Criada",
    titleNotify: "Atribuição",
    message1: "Os formulários foram atribuídos ao(s) usuário(s)",
    messageError: "Erro de mapeamento de formulário"
  }
};

export default { USERSVIEW };
